"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plug = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var plug = function plug(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'plug-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.23221 2.30507C8.52511 2.01217 8.99998 2.01217 9.29287 2.30507L17.7782 10.7903C18.071 11.0832 18.071 11.5581 17.7782 11.851L13.5355 16.0936C12.3509 17.2783 10.8376 17.1045 9.807 16.761C9.28529 16.5871 8.8327 16.3549 8.51159 16.1678L6.818 17.8614C6.52511 18.1543 6.05023 18.1543 5.75734 17.8614L2.22181 14.3259C2.08115 14.1852 2.00214 13.9945 2.00214 13.7956C2.00214 13.5966 2.08115 13.4059 2.22181 13.2652L3.9154 11.5716C3.72835 11.2505 3.49616 10.7979 3.32225 10.2762C2.97873 9.24563 2.80495 7.73233 3.98957 6.54771L8.23221 2.30507ZM5.47374 11.2246C5.69737 11.5232 5.66759 11.9408 5.40379 12.2046L3.8128 13.7956L6.28767 16.2704L7.87866 14.6794C8.14223 14.4159 8.55929 14.3859 8.8578 14.6089C8.85778 14.6089 8.85782 14.6089 8.8578 14.6089L8.85861 14.6095C8.85849 14.6094 8.85874 14.6096 8.85861 14.6095L8.86037 14.6108L8.87712 14.6229C8.89325 14.6344 8.91908 14.6525 8.95367 14.6759C9.023 14.7227 9.12665 14.7898 9.25722 14.8662C9.52102 15.0205 9.88135 15.2046 10.2813 15.3379C11.1069 15.6131 11.8917 15.6161 12.4749 15.033L16.1872 11.3207L8.76254 3.89606L5.05023 7.60837C4.46709 8.19151 4.47009 8.97631 4.74528 9.80188C4.87861 10.2019 5.06271 10.5622 5.21701 10.826C5.29338 10.9566 5.36052 11.0602 5.40733 11.1295C5.43069 11.1641 5.44884 11.19 5.46036 11.2061L5.47246 11.2229L5.47374 11.2246C5.47383 11.2247 5.47365 11.2245 5.47374 11.2246Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M13.8891 1.95151C14.182 2.24441 14.182 2.71928 13.8891 3.01217L11.7677 5.13349C11.4749 5.42639 11 5.42639 10.7071 5.13349C10.4142 4.8406 10.4142 4.36573 10.7071 4.07283L12.8284 1.95151C13.1213 1.65862 13.5962 1.65862 13.8891 1.95151Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M18.1316 6.19424C18.4245 6.48713 18.4245 6.96201 18.1316 7.2549L16.0103 9.37622C15.7174 9.66911 15.2425 9.66911 14.9496 9.37622C14.6567 9.08333 14.6567 8.60845 14.9496 8.31556L17.071 6.19424C17.3639 5.90135 17.8387 5.90135 18.1316 6.19424Z',
    fill: '#4B5563'
  }));
};

exports.plug = plug;